<template>
  <div class="organisation-tab mx-2">
    <BaseListToolbar
      title="Organisation Units"
      @search="text => (searchText = text)"
    />
    <v-btn-toggle
      class="organisation-section-buttons mb-4"
      v-model="selectedTab"
      tile
      group
      mandatory
      @change="handleSectionChange"
    >
      <v-btn
        v-for="(section, sectionKey, index) in sections"
        :key="sectionKey"
        :value="index"
      >
        {{ section }}
      </v-btn>
    </v-btn-toggle>
    <router-view :key="selectedTab" :searchText="searchText" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { last } from "lodash";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import BaseListToolbar from "@/components/common/Toolbar/BaseListToolbar";

const { mapState } = createNamespacedHelpers(AUTH_NAMESPACE);

export default {
  name: "OrganisationTab",
  components: { BaseListToolbar },
  data() {
    return {
      selectedTab: 0,
      searchText: ""
    };
  },
  methods: {
    handleSectionChange(selectedTab) {
      const sectionKey = Object.keys(this.sections)[selectedTab];
      this.$router.replace(`/settings/organisation/${sectionKey}`);
    }
  },
  mounted() {
    this.selectedTab = this.initialSection;
  },
  computed: {
    ...mapState({
      permissions: state => state.permissions
    }),
    initialSection() {
      const sectionKey = last(this.$router.currentRoute.path.split("/"));
      return Object.keys(this.sections).indexOf(sectionKey);
    },
    sections() {
      return {
        ...(this.permissions["settings.edit-organisation-unit"] && {
          active: "Active"
        }),
        ...(this.permissions["settings.edit-organisation-unit"] && {
          archived: "Archived"
        })
      };
    }
  }
};
</script>

<style lang="scss">
.organisation-tab {
  .organisation-section-buttons {
    display: flex;
    overflow: auto;
    justify-content: center;

    > .v-btn {
      &:not(.v-btn--round).v-size--default {
        height: 34px !important;
      }

      &.v-item--active::before {
        background-color: $button-select-marked;
        font-weight: bold;
      }

      &:not(.v-item--active) {
        font-weight: normal;
      }
    }
  }
}
</style>
